import { formatHumanName } from "@medplum/core";
import { Patient } from "@repo/domain";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ConsentIntro } from "@/features/consents";
import { consentStatusQuery } from "@/shared/edge/queries";
import { patientDomainIdFromProfile, selectedPatientFromProfile } from "@/shared/lib/patient-profile";

/** What the patient is about to sign; once consented, on to wherever they were going. */
export const Route = createFileRoute("/consent/")({
  beforeLoad: async ({ context, search }) => {
    const status = await context.queryClient.fetchQuery(
      consentStatusQuery(patientDomainIdFromProfile(context.profile)),
    );
    if (status.hasConsented) throw redirect({ href: search.redirect });
  },
  component: Page,
});

function Page() {
  const { profile } = Route.useRouteContext();
  const { redirect } = Route.useSearch();
  const selected = selectedPatientFromProfile(profile);
  const onBehalfOf =
    selected?.actingOnBehalf && Patient.legalName(selected?.name)
      ? formatHumanName(Patient.legalName(selected?.name))
      : undefined;
  return <ConsentIntro patientId={patientDomainIdFromProfile(profile)} redirect={redirect} onBehalfOf={onBehalfOf} />;
}
